var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blank-error',_vm._b({staticClass:"mb-0",attrs:{"title":_vm.translation.title,"variant":"light-danger"}},'blank-error',_vm.$props,false),[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.translation.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }